<script setup lang="ts">
import { useLoadingStore } from '@/stores/useLoadingStore'
import { storeToRefs } from 'pinia'

const loadingStore = useLoadingStore()
const { loading } = storeToRefs(loadingStore)
</script>

<template>
    <Transition name="slide-fade">
        <div
            class="loader"
            v-show="loading"
        ></div>
    </Transition>
</template>
<style lang="scss" scoped>
.loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: rgba($dn-green-light, 1);
    z-index: 9999;
    transition: 0.3s ease-in-out;
    opacity: 1;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 80%;
        height: 100%;
        transform: translateX(-10%);
        background-color: rgba($dn-green, 1);
        animation: loading 2s alternate infinite ease-in-out;
        transform-origin: center center;
        border-radius: 3px;
    }
}

.slide-fade-enter-active {
    transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
    transition: all 0.3s ease-in 0.5s;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateY(-5px);
    opacity: 0;
}

@keyframes loading {
    0% {
        width: 60%;
        transform: translateX(-40vw);
    }
    50% {
        width: 80%;
    }
    100% {
        width: 60%;
        transform: translateX(80vw);
    }
}
</style>
